import {Box, Progress, Text, rem} from '@mantine/core';
import {IconCheck, IconX} from '@tabler/icons-react';
import React from 'react';

function PasswordRequirement({meets, label}: {meets: boolean; label: string}) {
  return (
    <Text
      c={meets ? 'teal' : 'red'}
      style={{display: 'flex', alignItems: 'center'}}
      mt={7}
      size="sm">
      {meets ? (
        <IconCheck style={{width: rem(14), height: rem(14)}} />
      ) : (
        <IconX style={{width: rem(14), height: rem(14)}} />
      )}{' '}
      <Box ml={10}>{label}</Box>
    </Text>
  );
}

const requirements = [
  {re: /[0-9]/, label: 'Includes number'},
  {re: /[a-z]/, label: 'Includes lowercase letter'},
  {re: /[A-Z]/, label: 'Includes uppercase letter'},
  {re: /[$&+,:;=?@#|'<>.^*()%!-]/, label: 'Includes special symbol'},
];

function getStrength(password: string) {
  let multiplier = password.length > 5 ? 0 : 1;

  requirements.forEach(requirement => {
    if (!requirement.re.test(password)) {
      multiplier += 1;
    }
  });

  return Math.max(100 - (100 / (requirements.length + 1)) * multiplier, 10);
}

export interface PasswordStrengthProps {
  password: string;
}
export const PasswordStrength: React.FC<PasswordStrengthProps> = ({
  password,
}) => {
  const checks = requirements.map((requirement, index) => (
    <PasswordRequirement
      key={index}
      label={requirement.label}
      meets={requirement.re.test(password)}
    />
  ));

  const strength = getStrength(password);
  const color = strength === 100 ? 'teal' : strength > 50 ? 'yellow' : 'red';

  return (
    <>
      <Progress color={color} value={strength} size={5} mb="xs" mt="xs" />
      <PasswordRequirement
        label="Includes at least 6 characters"
        meets={password.length > 5}
      />
      {checks}
    </>
  );
};
